module.exports = __webpack_public_path__ + "static/media/regular.57eb69a1.svg";